import { Injectable } from '@angular/core';
import { Config } from 'app/shared/services/config';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { GetRainFallReportRequest, GetRainFallReportResponse, GetRainFallsRequest, RainFallStormsFreq } from './rainfall-freq.models';


@Injectable({
  providedIn: 'root'
})
export class RainfallFreqService {

  constructor(private http: HttpClient) { }

  public getRainFalls(params: GetRainFallsRequest) {
    return this.http.get<RainFallStormsFreq[]>(`${Config.urls.rainfallFreq}?cid=${params.cid}&start=${params.start}&end=${params.end}`).pipe(
      map((result) => {
        return result;
      }),
    );
  }

  public getRainFallReport(params: GetRainFallReportRequest) {
    return this.http.post<GetRainFallReportResponse>(`${Config.urls.rainfallFreqReport}?cid=${params.cid}`, params).pipe(
      map((result) => {
        return result;
      }),
    );
  }
}
